import { useBreakpoint } from "hooks/useBreakpoint";

export function useIsMobile() {
  const { xs } = useBreakpoint();
  return Boolean(xs);
}
